document.addEventListener('DOMContentLoaded', function () {
  var sentinel = document.getElementById('InfiniteScrollSentinel');
  if (!sentinel || !window.IntersectionObserver) return;

  var spinner = document.getElementById('InfiniteScrollSpinner');
  var endMessage = document.getElementById('InfiniteScrollEnd');
  var grid = document.getElementById('product-grid');
  if (!grid) return;

  var collectionUrl = sentinel.getAttribute('data-collection-url');
  var sectionId = sentinel.getAttribute('data-section-id');
  var currentPage = parseInt(sentinel.getAttribute('data-current-page'), 10) || 1;
  var totalPages = parseInt(sentinel.getAttribute('data-total-pages'), 10) || 1;
  var loading = false;

  function finish() {
    observer.disconnect();
    sentinel.hidden = true;
    if (endMessage) endMessage.hidden = false;
  }

  function loadNextPage() {
    if (loading || currentPage >= totalPages) return;
    loading = true;
    if (spinner) spinner.hidden = false;

    var nextPage = currentPage + 1;
    var url = collectionUrl + '?page=' + nextPage + '&section_id=' + sectionId;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load page ' + nextPage);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');

        if (newGrid) {
          // re-parent each fetched product card straight into the live
          // grid — this reuses the exact same server-rendered markup the
          // page already uses, so the card design can never drift
          Array.prototype.slice.call(newGrid.children).forEach(function (item) {
            grid.appendChild(item);
          });
        }

        currentPage = nextPage;
        loading = false;
        if (spinner) spinner.hidden = true;

        if (currentPage >= totalPages) {
          finish();
        }
      })
      .catch(function () {
        loading = false;
        if (spinner) spinner.hidden = true;
      });
  }

  if (currentPage >= totalPages) {
    sentinel.hidden = true;
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadNextPage();
        }
      });
    },
    { rootMargin: '600px 0px 600px 0px' }
  );

  observer.observe(sentinel);
});
